import {Funds} from './funds';
import {ProviderStatus} from './providerstatus';

export enum GameMode {
    Unknown = 0,
    SinglePlayer = 1,
    MultiPlayerAsync = 2,
    Rolls = 3,
}

export enum WinMode {
    Unknown = 0,
    SkillBased = 1,
    ChanceBased = 2,
}

export interface GameKind {
    GameKindId: string;
    Name: string;
    GameMode: GameMode;
    WinMode: WinMode;
}

export interface GameTemplate {
    Id: string;
    Title: string;
    Description: string;
    GameUrl: string;
    GameKindId: string;
    GameKind: GameKind | null;
    BannerUrl: string;
    IconUrl: string;
    Images: string[];
    Tags: string[];
    IsActive: boolean;
    IsFeatured: boolean;
    MinEntryFee: number | null;
    CreatedAt: string;
}

export interface GameTemplateWithStatus {
    Template: GameTemplate;
    ProviderStatus: ProviderStatus;
}

export interface AdminGameOverrides {
    Title: string | null;
    Description: string | null;
    BannerUrl: string | null;
    IconUrl: string | null;
    Images: string[] | null;
    IsActive: boolean | null;
    IsFeatured: boolean | null;
}

export interface AdminGame {
    Id: string;
    RealmId: string;
    Template: GameTemplateWithStatus;
    Overrides: AdminGameOverrides;
    CreatedAt: string;
}

export interface DisplayInfo {
    Name: string;
    Description: string;
    ImageUrl: string;
}

export interface GameVariantPlaceReward {
    Funds: Funds;
}

export type GameVariantRewardConfig =
    | { _type: 'fixed'; OrderedPlaceRewards: GameVariantPlaceReward[] };

export interface GameVariantGameTimings {
    GamePlayDurationSeconds: number;
    MaxGameDurationSeconds: number;
}

export interface GameVariantRollsBetLimits {
    Min: number;
    Max: number;
    Step: number;
}

export interface GameVariantRollsTimings {
    BettingDurationSeconds: number;
    DelayBeforeCalcResultsSeconds: number;
    DelayBeforeStartNextGameSeconds: number;
    MaxGameDurationSeconds: number;
}

export type GameVariantModeConfig =
    | { _type: 'multiPlayerAsync'; MaxPlayers: number; EntryFee: Funds; GameReward: GameVariantRewardConfig; Timings: GameVariantGameTimings }
    | { _type: 'rolls'; CurrencyType: string; RollsBetLimits: GameVariantRollsBetLimits; HouseFeePercents: number; GameTimings: GameVariantRollsTimings }
    | { _type: 'singlePlayer'; CurrencyType: string };

export interface GameVariantTemplate {
    GameVariantTemplateId: string;
    GameKindId: string;
    IsActive: boolean;
    Notes: string;
    DisplayInfo: DisplayInfo;
    ModeConfig: GameVariantModeConfig;
}

export interface GameVariant {
    GameVariantId: string;
    Template: GameVariantTemplate;
    IsActive: boolean | null;
    DisplayInfo: DisplayInfo | null;
}
